import { useDispatch } from "react-redux";

import {
  getListData,
  deleteConditionData,
  createConditionData,
  editConditionData,
  getConstantsData,
  getViewConditionData,
  clearDeleteConditionState,
  clearListState,
  clearConstantsState,
  clearCreateConditionState,
  clearEditConditionState,
  clearViewConditionState,
  payloadSubAffDealsV2List,
	getFilterCreatorData,
} from "./index";


export const useSubAffDealsV2 = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadSubAffDealsV2List) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

  const deleteCondition = (data: any) => dispatch(deleteConditionData(data));
  const clearDeleteCondition = () => dispatch(clearDeleteConditionState());

  const getConstants = () => dispatch(getConstantsData());
  const clearConstants = () => dispatch(clearConstantsState());

  const createCondition = (data: any) => dispatch(createConditionData(data));
  const clearCreateCondition = () => dispatch(clearCreateConditionState());

  const getViewCondition = (id: string) => dispatch(getViewConditionData(id));
  const clearViewCondition = () => dispatch(clearViewConditionState());

  const editCondition = (data: any) => dispatch(editConditionData(data));
  const clearEditCondition = () => dispatch(clearEditConditionState());

	const getFilterCreator = (data: any) => dispatch(getFilterCreatorData(data));

  return {
    getList,
    clearList,
    deleteCondition,
    clearDeleteCondition,
    getConstants,
    clearConstants,
    createCondition,
    clearCreateCondition,
    getViewCondition,
    clearViewCondition,
    editCondition,
    clearEditCondition,
	  getFilterCreator,
  }
}
